import { List, ListItem, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export const Park = () => {
  return (
    <div className="page">
      <Typography gutterBottom variant="h3" align="center">
        What's In Our Park
      </Typography>
      <List
        sx={{
          listStyleType: "disc",
          pl: 2,
          "& .MuiListItem-root": {
            display: "list-item",
          },
        }}
      >
        <ListItem sx={{ pl: 0 }}>
          On-site hiking trail (2km loop with 500m side loop)
        </ListItem>
        <ListItem sx={{ pl: 0 }}>Playground</ListItem>
        <ListItem sx={{ pl: 0 }}>
          Regulation-size sand volleyball court
        </ListItem>
        <ListItem sx={{ pl: 0 }}>Fishing off our docks</ListItem>
        <ListItem sx={{ pl: 0 }}>
          Small sand beach for swimming (our campground is on a small sheltered
          inlet that opens up into Lake Huron / Georgian Bay)
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          Bicycle rentals and boat rentals (weather dependent) (
          <Link to="/rentals">click here</Link> for rental prices)
        </ListItem>
        <ListItem sx={{ pl: 0 }}>Two spacious open play/sports areas</ListItem>
        <ListItem sx={{ pl: 0 }}>Natural ponds and wetlands area</ListItem>
        <ListItem sx={{ pl: 0 }}>
          Picnic table and and campfire pit on each site
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          Dump station (free for our campers) and mobile pump out service ($20)
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          Clean modern washroom facilities with hot showers ($0.25/4 mins)
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          Docking facilities for small boats and seadoos (dependent on annual
          water level)
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          Store / office at the front of the park that sells camping essentials
          (<Link to="/storeitems">click here</Link> for a full list of store
          items)
        </ListItem>
      </List>
    </div>
  );
};
